import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getDashboardV2AppointmentsRequest = (query, params) =>
  restRequest({
    uri: '../v2/dashboard/appointments',
    query,
    method: HttpMethods.Get,
    ...params,
  });
